import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '../globals'
import { comRedirect, urlDeLoginCom, registrarVolta } from '../utils/returnUrl'

import homeRoutes from './home'
import corretouLeadsRoutes from './corretouLeads'
import authRoutes from './auth'
import basicRoutes from './basic'
import multicalculoRoutes from './multicalculo'
import seguradosRoutes from './segurados'
import onboardingRoutes from './onboarding'
import centralVendasRoutes from './centralVendas'
import sinistrosRoutes from './sinistros'
import financeiroRoutes from './financeiro'
import relatoriosRoutes from './relatorios'
import suporteRoutes from './suporte'
import configuracaoRoutes from './configuracao'
import minhaContaRoutes from './minhaConta'
import notificacaoesRoutes from './notificacao'
import buscasRoutes from './buscas'
import tarefasRoutes from './tarefas'
import marketingRoutes from './marketing'
import chatRoutes from './chat'
import assinatura from './assinatura'
import inteligenciaRoutes from './inteligencia'
import segurancaRoutes from './seguranca'
import mensagemRoutes from './mensagem'
import eventBus from '../eventBus/eventBus'
import descadastroEmailRoutes from './cancelamentoEmail'
import tabelaAutomatizacaoRoutes from './tabelaAutomatizacao'
import politicaRoutes from './politica'
import termoRoutes from './termos'
import permissoesSeguradosRoutes from './permissoesSegurados'
import telegramBotRoutes from './telegramBot'
import atualicacaoRoutes from './atualizacao'
import referBrokerRoutes from './referBroker'
import retrospectivaRoutes from './retrospectiva'
import driver from '../driver'
import filtros from './filtros'
import moment from 'moment'
import { isFirefox } from '../extensions/utils'
import { identifyHubSpotUser, trackHubSpotPageView } from '../utils/hubspotTracking'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
    { 
        path: '', 
        redirect: '/home' 
    },
    {
        path: '/teste',
        component: () => import('@/components/basic/teste')
    },
    // Rota específica para o Jam recorder
    {
        path: '/recorder',
        component: () => import('@/components/basic/recorder')
    },
    { 
        path: '*', 
        component: () => import('@/components/basic/404')
    },
    { 
        path: '/400', 
        component: () => import('@/components/basic/400')
    },
    { 
        path: '/confirmacaoEmail', 
        component: () => import('@/components/confirmacaoEmail/confirmacaoEmail')
    }
].concat(basicRoutes)
 .concat(authRoutes)
 .concat(homeRoutes)
 .concat(corretouLeadsRoutes)
 .concat(multicalculoRoutes)
 .concat(seguradosRoutes)
 .concat(onboardingRoutes)
 .concat(centralVendasRoutes)
 .concat(sinistrosRoutes)
 .concat(financeiroRoutes)
 .concat(relatoriosRoutes)
 .concat(suporteRoutes)
 .concat(configuracaoRoutes)
 .concat(minhaContaRoutes)
 .concat(notificacaoesRoutes)
 .concat(buscasRoutes)
 .concat(tarefasRoutes)
 .concat(marketingRoutes)
 .concat(chatRoutes)
 .concat(assinatura)
 .concat(inteligenciaRoutes)
 .concat(segurancaRoutes)
 .concat(mensagemRoutes)
 .concat(descadastroEmailRoutes)
 .concat(filtros) 
 .concat(tabelaAutomatizacaoRoutes)
 .concat(politicaRoutes)
 .concat(permissoesSeguradosRoutes)
 .concat(telegramBotRoutes)
 .concat(termoRoutes)
 .concat(atualicacaoRoutes)
 .concat(referBrokerRoutes)
 .concat(retrospectivaRoutes)
 
const router = new Router({
    base: '/',
    mode: 'history',
    routes: ROUTES
})

let isFirstNavigation = true

router.afterEach((to) => {
    // On small screens collapse sidenav
    if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
        setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
    }

    const authState = Vue.$store && Vue.$store.state && Vue.$store.state.auth
    if (authState && authState.email && !authState.segfyer) {
        identifyHubSpotUser(authState.email)
    }

    if (isFirstNavigation) {
        isFirstNavigation = false
    } else {
        trackHubSpotPageView(to.fullPath)
    }

    // Scroll to top of the page
    globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
    document.body.classList.add('app-loading')

    driver.driver.reset()

    if (globals().isMobile) {
        eventBus.$emit('resetInput')
    }

    let resolved = false
    const guardNext = (...args) => {
        if (resolved) return
        resolved = true
        next(...args)
    }

    // Add tiny timeout to finish page transition
    setTimeout(() => guardNext(), 10)

    // Vamos checar se estamos direcionando o usuário
    // corretamente, baseado em seu status de autenticação
    checkAuth(to, from, guardNext)
})

function checkAuth (to, from, next) {
    let state = Vue.$store.state

    if (to.path === '/multicalculo/orcamento-redirect') {
        next({ path: setURL('/multicalculo/hfy-auto') })

        if (isFirefox(navigator.userAgent)) {
            setTimeout(() => {
                console.log('redirect Firefox')
                window.location.reload()
            }, 3000)
          } else {
            // User is not using Firefox
            setTimeout(() => {
                console.log('redirect')
                window.location.reload()
            }, 1300)
          }
    }

    if (to.path.includes('/confirmacaoEmail')) {
        next({ component: () => import('@/components/confirmacaoEmail/confirmacaoEmail') })
    } else if (to.path !== '/assinatura/nova' && !to.path.includes('/logoff') && state.auth.isAuth && state.auth.dataTrialFim !== null && moment(state.auth.dataTrialFim) < moment()) {
        // se usuário em período TRIAL && Expirado
        next({ path: setURL('/assinatura/nova') })
    } else if (state.auth.isAuth && !to.query.redirect && (to.path === '/home' || to.path === '/')) {
        const pendingUrl = sessionStorage.getItem('sso_return_url')
        if (pendingUrl) {
            sessionStorage.removeItem('sso_return_url')
            registrarVolta(sessionStorage, pendingUrl)
            next({ path: comRedirect(pendingUrl) })
        }
    } else if (to.path.includes('/login') && state.auth.isAuth && !to.path.includes('/logoff')) {
        if (state.auth.isMeusPagamentosRestrito) {
            next({ path: '/financeiro/meusPagamentos?redirect=true' })
        } else if (to.query.return_url) {
            next({ path: to.query.return_url })
        } else {
            next({ path: '/home' })
        }
    } else if (to.matched.some(m => m.meta.auth) && !state.auth.isAuth) {
        if (to.path && to.path !== '/' && to.path !== '/home') {
            // fullPath e não path: o ?q= dos links de e-mail precisa sobreviver ao login
            sessionStorage.setItem('sso_return_url', to.fullPath)
        }
        next({ path: urlDeLoginCom(to.fullPath) })
    } else if (
        state.auth.isAuth &&
        state.auth.isMeusPagamentosRestrito &&
        !to.path.startsWith('/financeiro/meusPagamentos') &&
        !to.path.includes('/logoff')
    ) {
        next({ path: '/financeiro/meusPagamentos?redirect=true' })
    } else if (
        state.auth.isAuth &&
        !state.auth.isMeusPagamentosRestrito &&
        !state.auth.acessoMeuPlanoSegfy &&
        to.path.startsWith('/financeiro/meusPagamentos')
    ) {
        next({ path: setURL('/unauthorized') })
    } else if (to.matched.some(m => m.meta.needsPermission) && !validatePermission(state, to.matched)) {
        // Se a página está marcada que precisa de permissão, verificar no login na store
        next({ path: setURL('/unauthorized') })
    } else if (to.query.redirect === undefined) {
        if (from.query.return_url !== undefined && state.auth.isAuth) {
            // mesmo cuidado do ramo acima: o return_url agora carrega a rota inteira,
            // então concatenar '?redirect=true' aqui geraria '?q=x?redirect=true'
            next({ path: comRedirect(from.query.return_url) })
        }
        if (Vue.$store.state.auth.isAuth) {
            // TODO: SignalR
            // connection.connection.start()
        }
    }
}

function validatePermission (state, matched) {
    let autorizado = true
    matched.filter(a => a.meta.needsPermission).forEach(function (item) {
        let prop = item.meta.needsPermission // qual a permissão que vamos procurar no auth store
        let permissao = state.auth[prop]
        if (item.meta.inversePermission === true) { // casos onde a propriedade está invertida, ie.: bloquearOrcamentoAuto
            permissao = !permissao
        }

        if (permissao === false) { // para qualquer rota sem permissão, já não deve ser autorizado
            autorizado = false
        }            
    })

    return autorizado
}

function setURL (link) {
    return link + '#navr=' + uid().split('-')[0]
}

function uid () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}

export default router
